import { ApiRequest } from 'framework/api';

export function updateDashboardPath({
	accountId,
	path,
	dashboardId,
}: {
	accountId?: string;
	path: string;
	dashboardId: string;
}) {
	return new ApiRequest<string>({
		url: `dashboards/updatePath`,
		accountId,
		accountBased: true,
		method: 'POST',
		payload: {
			path,
			dashboardId,
		},
	});
}
